module.exports = __webpack_public_path__ + "img/myItems.d9cc5891.svg";